import { listItemIconClasses } from '@mui/material/ListItemIcon';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiMenuItem = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: {
      borderRadius: '8px',
      gap: 'var(--ListItem-gap)',
      fontSize: '0.875rem',
      minHeight: '32px',
      paddingBlock: 'var(--MenuItem-paddingBlock, 6px)',
      paddingInline: 'var(--MenuItem-paddingInline, 8px)',
      '&:hover': { backgroundColor: 'var(--mui-palette-background-level1)' },
      '&.Mui-selected': {
        backgroundColor: 'var(--mui-palette-background-level2)',
        '&:hover': { backgroundColor: 'var(--mui-palette-background-level2)' },
      },
      [`& .${listItemIconClasses.root}`]: { minWidth: 'auto' },
    },
  },
} satisfies Components<Theme>['MuiMenuItem'];
